import * as React from "react"

import Seo from "../components/seo";
import Header from '../components/Header';
import Banner from '../components/Banner';
import Steps from '../components/Steps';
import Mentioned from '../components/Mentioned';
import Separator from '../components/Separator';
import CompletelySafe from '../components/CompletelySafe';
import FitnessList from '../components/FitnessList';
import Trustpilot from '../components/Trustpilot';

import GlobalStyle from '../styles/global';
import * as S from '../styles/index';

const Index = () => {
  return (
    <S.Container>
      <Seo title="Home" description="Ujoose Fitness Pros" />
      <GlobalStyle />
      <Header />
      <Banner />
      <Separator text="How does it work ?" />
      <Steps />
      <Mentioned />
      <Separator text={<Trustpilot />} />
      <CompletelySafe />
      <FitnessList />
    </S.Container>
  );
}

export default Index;
